import React from 'react';
import { useEditor } from '../../context/EditorContext';
import { useWrapPoints } from '../../hooks/useWrapPoints';
import { DropdownMenuItem, DropdownMenuSeparator } from '../ui/dropdown-menu';
import { Spline, RotateCcw } from 'lucide-react';

/**
 * "Edit Wrap Points" / "Reset Wrap Points" entries shared by every Wrap Text ribbon menu.
 * `ids` = objects the menu acts on; `testPrefix` keeps data-testids unique per ribbon tab.
 */
export const WrapPointsMenuItems = ({ ids = [], testPrefix = 'ribbon-menu' }) => {
  const { getActiveObjects } = useEditor();
  const { enter, reset, canEdit, hasCustom } = useWrapPoints();
  const objs = getActiveObjects().filter((o) => ids.includes(o.id));
  const one = objs.length === 1 ? objs[0] : null;
  return (
    <>
      <DropdownMenuSeparator />
      <DropdownMenuItem disabled={!one || !canEdit(one) || !!one.locked} onClick={() => one && enter(one.id)} className="text-[13px]" data-testid={`${testPrefix}-edit-wrap-points`}>
        <Spline className="w-4 h-4 mr-2 text-muted-foreground" /> Edit Wrap Points
      </DropdownMenuItem>
      <DropdownMenuItem disabled={!objs.some((o) => hasCustom(o))} onClick={() => reset(ids)} className="text-[13px]" data-testid={`${testPrefix}-reset-wrap-points`}>
        <RotateCcw className="w-4 h-4 mr-2 text-muted-foreground" /> Reset Wrap Points
      </DropdownMenuItem>
    </>
  );
};
